const preChatCloseMessagePopup = async (me, e) => {
    me.setLastMessageCache(-1);
    me.resetMessageCounterCache();
    // show online tag
    const roundedMessagePopup = document.getElementsByName('apexchat_prechat_message_bubble');
    // me.$(me.DOM.getElementById('apexchat_prechat_message_popup_container'))
    // .find('.apexchat_prechat_message_bubble');
    if (roundedMessagePopup.length > 0) {
        me.templateRenderer.renderer.showOnlineAgentTag();
    }
    if (e) {
        e.stopPropagation();
        e.preventDefault(); // resolve scrolling issue on iphone;
    }
    // CHAT-8951: There are two specific scenarios in which agentScriptAnswerId become 0 or -1 in specific cases.
    // we need to hide popup messages and do nothing.
    if (me.agentScriptAnswerId === 0 || me.agentScriptAnswerId === -1) {
        me.setMessageCounterCache(-1);
        me.templateRenderer.hideMessagePopup();
    } else if (!me.options.videoGreetEnabled){
        const module = await import(/* webpackChunkName: "handlePrechatQuestionType" */ './handlePrechatQuestionType')
        const handlePrechatQuestionType = module.default;
        handlePrechatQuestionType(me, { isSkipped: true, answers: '' });
    }
    // when closing prechat msg IFrame should resize.
    me.postMessage({
        event: 'prechat-auto-resizing',
        data: {
            isResetIframe: true,
            isSingleMsg: true,
            hideCloseButton: true // we need to hide close button
        }
    });
    window.clearTimeout(me.messageTimeout);
}
export default preChatCloseMessagePopup;